import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useTransactionAPIStore } from '@/stores'
import { Transaction } from '@/types'

export const useTransactionStore = defineStore('transaction', () => {
  const txAPIStore = useTransactionAPIStore()
  const accountTransactionList = computed<Transaction[]>(() => {
    return Object.values(txAPIStore.transactionListByAccountId)
      .flat()
      .map((rawTx) => {
        if (rawTx) {
          return new Transaction(rawTx)
        }
      })
      .filter((val): val is Transaction => !!val)
  })
  const accountTokenTransactionList = computed<Transaction[]>(() => {
    return Object.values(txAPIStore.transactionListByAccountTokenId)
      .flat()
      .map((rawTx) => Object.values(rawTx))
      .flat(2)
      .map((rawTx) => {
        if (rawTx) {
          return new Transaction(rawTx)
        }
      })
      .filter((val): val is Transaction => !!val)
  })

  const getTransactionList = (params: {
    accountId: string
    accountTokenId?: string
  }) => {
    if (params.accountTokenId) {
      // V2: 토큰 트랜잭션은 accountTokenId로만 필터링
      // (V2 API에서 tx.accountId가 토큰 계정 ID를 반환하므로)
      return accountTokenTransactionList.value.filter(
        (tx) => tx.accountTokenId === params.accountTokenId,
      )
    }
    return accountTransactionList.value.filter(
      (tx) => tx.accountId === params.accountId,
    )
  }

  const getTransactionById = (params: {
    txId: string
    accountTokenId?: string
  }) => {
    if (params.accountTokenId) {
      return accountTokenTransactionList.value.find(
        (tx) => tx.id === params.txId,
      )
    }
    return accountTransactionList.value.find((tx) => tx.id === params.txId)
  }

  const getTransactionByTxid = (params: {
    txId: string
    accountTokenId?: string
  }) => {
    if (params.accountTokenId) {
      return accountTokenTransactionList.value.find(
        (tx) => tx.txid === params.txId,
      )
    }
    return accountTransactionList.value.find((tx) => tx.txid === params.txId)
  }

  return {
    accountTransactionList,
    accountTokenTransactionList,
    getTransactionList,
    getTransactionById,
    getTransactionByTxid,
  }
})
